import { Link } from "react-router-dom";
import { SrIcon } from "@/components/ui/SrIcon";
import { useProjectFreelancers } from "@/hooks/use-freelancer-projects";
import { formatNOK } from "@/lib/format";

/**
 * VIB-2927: lesevisning av frilanserne på prosjektet i Team & eierskap.
 * Rolle = eksterne linjer frilanseren står på. Fakturert = bilag fra koblede
 * leverandører (delmengde av GEEK-kostnaden, ikke en KPI).
 */
export function ProjectFreelancersSection({ projectId }: { projectId: string }) {
  const { data: rows = [] } = useProjectFreelancers(projectId);
  if (rows.length === 0) return null;

  return (
    <div className="border-t pt-3">
      <div className="mb-1 flex items-center justify-between">
        <h4 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Frilansere</h4>
        <Link to={`/prosjekter/${projectId}/budsjett`} className="text-xs text-primary hover:underline">Timetildeling</Link>
      </div>
      <ul className="space-y-1.5">
        {rows.map((r) => {
          const role = r.lines.map((l) => l.description).filter(Boolean).join(", ");
          return (
            <li key={r.freelancer_id} className="flex items-center gap-3 text-sm">
              <SrIcon name="film" className="h-4 w-4 shrink-0 text-muted-foreground" />
              <div className="min-w-0 flex-1">
                <Link to={`/frilansere/${r.freelancer_id}`} className="font-medium hover:underline">{r.freelancer_name}</Link>
                {role && <div className="truncate text-xs text-muted-foreground">{role}</div>}
              </div>
              {r.voucher_count > 0 && (
                <span className="text-xs tabular-nums text-muted-foreground" title="Fakturert via bilag fra koblet leverandør">
                  {formatNOK(r.invoiced)}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
